/**
 * @license
 * Copyright Workylab. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://raw.githubusercontent.com/workylab/materialize-angular/master/LICENSE
 */

export interface TextAreaModel {
  className: string;
  disabled: boolean;
  floatLabel: string;
  hasCounter: boolean;
  id: string | null;
  maxLength: number;
  minLength: number;
  name: string;
  placeholder: string;
  required: boolean;
  rows: number;
  value: string;
}
